module.exports = [{
      plugin: require('/Users/geoffreyhunt/Documents/Temp/leaderex/website/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-125051348-1","head":false},
    },{
      plugin: require('/Users/geoffreyhunt/Documents/Temp/leaderex/website/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/geoffreyhunt/Documents/Temp/leaderex/website/node_modules/gatsby-plugin-emotion/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/geoffreyhunt/Documents/Temp/leaderex/website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
